/* eslint-disable react-hooks/exhaustive-deps */
import { HeaderDiv, TextExample, FieldLabel } from "../../../components/styledComponents/Components.styles"
import { getSelectStyles } from "../../../components/styledComponents/ReactSelectStyles"
import TooltipIcon from "../../../components/styledComponents/TooltipIcon"
import Select from "react-select"
import { useDataContext } from "../../../components/DataProvider/DataContext"
import { Tooltip } from "@mui/material"
import { ResetValueButton } from "./ResetValueButton"
import type { FormFieldProps } from "../../../models/FormFieldProps"
import palette from "../../../utilities/palette"
import WarningTooltipIcon from "../../styledComponents/WarningTooltipIcon"
import { checkIfFieldMatchesArchitecture, checkIfFieldIsPrefilledByCatalog, checkIfFieldIsRequiredPerArchitecture } from "../../../utilities/architectureTypeDataProcess"

export function SelectField(
    props : Readonly<FormFieldProps>
) {

    const { architectureType } = useDataContext();

    const {
        // Essential Information props
        label,
        value,
        placeholder,
        onChange,
        onFocus,
        onRevert,
        textExample,
        textHint,
        errorMessage,
        overridenErrorMessage,
        isLoading,
        isDisabled,
        isMulti,
        isClearable,
        required,
        options,
        components,
        pathToField,
        isPrefilledValueChanged,
        stylingVariant,

        // ID props
        idLabel,
        idInput,
        idError,

        // name props
        nameInput,
    } = props;

    const isArchitectureTypeMatch = pathToField ? checkIfFieldMatchesArchitecture(pathToField, architectureType) : true;
    const isPrefilledByCatalog = pathToField ? checkIfFieldIsPrefilledByCatalog(pathToField, architectureType) : false;
    const isRequired = required || (pathToField ? checkIfFieldIsRequiredPerArchitecture(pathToField, architectureType) : false);


    // Helper function to determine tooltip title text
    const getTooltipTitle = () => {
        if (!isArchitectureTypeMatch) {
            return "Disabled due to architecture type mismatch";
        }
        
        return "";
    };

    // Helper function to determine placeholder text
    const getPlaceholderText = () => {
        if (!isArchitectureTypeMatch) {
            return "";
        }
        
        return placeholder || "--Please Select--";
    };

    // Helper function to check if field should be disabled
    const shouldFieldBeDisabled = () => {
        if (!isArchitectureTypeMatch) return true;
        if (isDisabled) return true;
        return false;
    };

    return (
        isArchitectureTypeMatch && (
        <HeaderDiv style={{width: '560px'}}>
                <FieldLabel id={idLabel} variant={stylingVariant}>
                    {label}
                    {isRequired && <span style={{color: palette.stepper.error}}> *</span>}
                    {textExample && <>{" "}<TextExample>{textExample}</TextExample></>}
                    {" "}
                    {textHint && <TooltipIcon content={textHint}/>}
                    {isPrefilledValueChanged && isPrefilledByCatalog === true && <WarningTooltipIcon content={"This field's value is different from the registered value"}/>} 
                    {" "}:

                </FieldLabel>
                <Tooltip 
                    placement="top-end"
                    title={getTooltipTitle()}
                    >
                    <div style={{
                        width: 'fit-content', 
                        display: 'flex', 
                        flexDirection: 'row',
                        margin: '5px 0'
                    }}>
                        <Select //AsyncSelect uses unsafe-inline styling. This must be allowed in the manifest.
                            isMulti={isMulti}
                            name={nameInput}
                            id={idInput}
                            options={options}
                            value={
                                !isArchitectureTypeMatch ? null : value
                            }
                            isLoading={isLoading}
                            isDisabled={shouldFieldBeDisabled()}
                            isClearable={isClearable}
                            placeholder={getPlaceholderText()}
                            onFocus={onFocus}
                            onChange={(selectedOptions) =>
                                onChange(selectedOptions)
                            }
                            styles={getSelectStyles(isArchitectureTypeMatch, stylingVariant, !!errorMessage)}
                            components={components}
                        />
                        <ResetValueButton
                            isPrefilledByCatalog={isPrefilledByCatalog}
                            isPrefilledValueChanged={isPrefilledValueChanged}
                            onClick={onRevert}
                        />

                    </div>
                </Tooltip>

                {errorMessage && (
                    <span id={idError} style={{ color: palette.stepper.error }}>{
                        // If overridenErrorMessage is provided, use it. Otherwise, use the default errorMessage
                        overridenErrorMessage ?? errorMessage}</span>
                )}

      </HeaderDiv>
      )
    )
}